// Module
var code = "<template class=\"ess-${valid ? 'valid' : 'invalid'}\"> <div show.bind=\"!valid\"> <slot></slot> </div> </template> ";
// Exports
module.exports = code;